

















































































































import { Component, Vue} from 'vue-property-decorator'; // デコレータ

// 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] upd start
//@Component
//export default class KanriMenu extends Vue {}
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);
@Component
export default class KanriMenu extends ApiAccessBase {
  private orgFlg: boolean = false;
  private mstFlg: boolean = false;
  private mssFlg: boolean = false;
  private created() {
    this.orgFlg = this.checkAuthority(AuthoritiesId.ORG_READ);
    this.mstFlg = this.checkAuthority(AuthoritiesId.MST_READ);
    this.mssFlg = this.checkAuthority(AuthoritiesId.MSS_READ);
  }
}
// 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] upd end
